<template>
  <div class="h-100 bg-default">
    <div class="white d-flex align-center justify-center py-8 elevation-3">
      <v-container>
        <div class="text-center">
          <h4 class="secondary-font">Minhas Respostas</h4>
          <h5 class="secondary-font text--secondary mt-2">
            Visualização das respostas enviadas anteriormente. Não é possível editar.
          </h5>
        </div>
      </v-container>
    </div>

    <v-container class="pt-5">
      <v-row justify="center">
        <v-col cols="12" sm="10">
          <div class="px-3">
            <template v-if="loading">
              <v-row justify="center" class="mt-10">
                <v-progress-circular indeterminate color="primary" />
              </v-row>
            </template>

            <template v-else-if="perguntas.length">
              <div v-for="(grupo, nomeCategoria) in perguntasAgrupadas" :key="nomeCategoria">
                <h3 class="text-left title primary--text mt-5">
                  <strong>{{ nomeCategoria }}</strong>
                </h3>
                <v-row>
                  <v-col cols="12" md="6" v-for="pergunta in grupo" :key="pergunta.id">
                    <v-row>
                      <v-col cols="12">
                        <h5 class="-font">{{ pergunta.text }}</h5>
                      </v-col>
                      <v-col cols="12">
                        <v-radio-group
                          :value="respostas[pergunta.id] && respostas[pergunta.id].value"
                          disabled
                          hide-details
                        >
                          <v-radio
                            v-for="option in pergunta.options"
                            :key="option.value"
                            :label="option.label"
                            :value="option.value"
                            class="secondary-font font-weight-bold"
                          />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </template>
          </div>

          <v-row justify="center" class="mt-8 mb-8">
            <v-btn rounded outlined color="primary" class="secondary-font text-capitalize" @click="$router.back()">
              <v-icon left>mdi-arrow-left</v-icon>
              Voltar
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import avaliacaoPsicossocialService from '@/services/avaliacaoPsicossocial'

export default {
  props: {
    idMapeamento: {
      type: [String, Number],
      required: true
    }
  },
  data: () => ({
    loading: true,
    perguntas: [],
    respostas: {}
  }),
  computed: {
    perguntasAgrupadas() {
      return this.perguntas.reduce((acc, pergunta) => {
        const nomeCategoria = pergunta.categoria.nome
        if (!acc[nomeCategoria]) acc[nomeCategoria] = []
        acc[nomeCategoria].push(pergunta)
        return acc
      }, {})
    }
  },
  async mounted() {
    try {
      const { data } = await avaliacaoPsicossocialService.getRespostasDoFuncionario(this.idMapeamento)
      this.perguntas = data.perguntas
      this.respostas = data.respostas
    } catch (e) {
      this.$store.dispatch('app/showErrorMessage', 'Não foi possível carregar suas respostas.')
    } finally {
      this.loading = false
    }
  }
}
</script>
